import { useQuery } from '@tanstack/react-query'

import { LevelCosmeticEntry } from '../types'

import { api } from '@/shared/services/api'

export interface CosmeticsProfileQueryData {
  cosmetics?: LevelCosmeticEntry[]
}

export const userCosmeticsProfileQueryKey = [
  'user',
  'cosmetics',
  'profile'
] as const

export async function fetchUserCosmeticsProfile() {
  const { data } = await api.get<CosmeticsProfileQueryData>('/user/cosmetics/profile')
  return data
}

export function useLevelCosmeticUnlock(levelId: number | null): {
  unlockedCosmetics: LevelCosmeticEntry[]
  isLoading: boolean
} {
  const { data, isLoading } = useQuery({
    queryKey: userCosmeticsProfileQueryKey,
    queryFn: fetchUserCosmeticsProfile,
    enabled: levelId !== null,
    staleTime: 0
  })

  const entries: LevelCosmeticEntry[] = Array.isArray(data?.cosmetics)
    ? data.cosmetics
    : []

  const unlockedCosmetics = entries.filter(
    entry =>
      entry.kind === 'avatar' &&
      entry.status === 'unlocked' &&
      entry.criteria.level_ids?.includes(levelId as number)
  )

  return { unlockedCosmetics, isLoading }
}
